/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { colors, typography, onMedia, GLOBAL_SHADOW } from "../styles"

export const SecondaryAction = ({ children, href, ...restProps }) => {
  return (
    <a
      href={href}
      css={{
        display: "inline-block",
        padding: "0.25rem 0.5rem",
        margin: "1rem",
        color: "white",
        fontFamily: typography.MUSEO,
        fontWeight: 500,
        fontSize: "1rem",
        textDecoration: "none",
        textAlign: "center",

        backgroundColor: colors.DARK_GRAY,
        boxShadow: GLOBAL_SHADOW,
        ...onMedia("hover: hover", {
          "&:hover": {
            color: colors.DARK_GRAY,
            backgroundColor: "white",
          },
        }),
      }}
      {...restProps}
    >
      {children}
    </a>
  )
}
